import { Paper, Typography, Box } from '@mui/material';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';

// Placeholder para las pantallas del admin que aún no se construyen.
const AdminPlaceholder = ({ titulo = 'Sección' }) => (
  <Paper sx={{ p: 6, borderRadius: 3, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
      <ConstructionOutlinedIcon sx={{ fontSize: 48, color: 'text.secondary' }} />
    </Box>
    <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>{titulo}</Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      Esta sección estará disponible próximamente.
    </Typography>
  </Paper>
);

export default AdminPlaceholder;
